import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { getProductReturn } from '../amazon.services';
import '../amazon.scss';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { formatTo0Decimal, isEmptyArray } from '../../common/util.services';

const AmazonProductReturn = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [prdReturn, setPrdReturn] = useState(rows)
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState('count');
  const [groupBy, setGroupBy] = useState('total');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'month', headerName: 'Month', width: 90, filterable: false, sortable: false, editable: false},
    { field: 'product', headerName: 'Product', width: 120, filterable: false, sortable: false, editable: false, },
    { field: 'color', headerName: 'Color', width: 120, filterable: false, sortable: false, editable: false,},
    { field: 'size', headerName: 'Size', width: 120, filterable: false, sortable: false, editable: false,},
    { field: 'unitCount', headerName: 'Pack Of', width: 100, filterable: false, sortable: false, editable: false },
    { field: 'quantity', headerName: 'Sale #', width: 100, filterable: false, sortable: false, editable: false },
    { field: 'returnQty', headerName: 'Return #', width: 100, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatTo0Decimal(value)
    },
    { field: 'returnValue', headerName: 'Ret Value', width: 100, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatTo0Decimal(value)
    },
    { field: 'returnPct', headerName: 'Return (%)', width: 100, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatTo0Decimal(value) + '%'
    },
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let data = [...props.productData, orderBy, groupBy];
      getProductReturn(data, page, pageSize, appContext,
        (response: any) => {
          setPrdReturn(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [orderBy, groupBy, page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const handleOrderBy = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOrderBy((event.target as HTMLInputElement).value);
  }

  const handleGroupBy = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGroupBy((event.target as HTMLInputElement).value);
  }

  const getMainPanel = () => {
    return <>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6}>
        <FormControl>
          <FormLabel sx={{ textAlign: 'center', marginRight: '20px'}} id="orderBy">Sorting</FormLabel>
          <RadioGroup defaultValue="count" name="orderBy" row={true} onChange={handleOrderBy}>
            <FormControlLabel value="count" control={<Radio />} label="Count" />
            <FormControlLabel value="value" control={<Radio />} label="Value" />
            <FormControlLabel value="retPct" control={<Radio />} label="Ret %" />
          </RadioGroup>
        </FormControl>
        <FormControl>
          <FormLabel sx={{ textAlign: 'center', marginRight: '20px'}} id="groupBy">Aggregation</FormLabel>
          <RadioGroup defaultValue="total" name="groupBy" row={true} onChange={handleGroupBy}>
            <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
            <FormControlLabel value="total" control={<Radio />} label="Total" />
          </RadioGroup>
        </FormControl>
       </Grid>
      </Grid>
      <IGridComponent title={''} rows={prdReturn} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          getRowId={(row: any) => row.rowId} showAction={false}/>
    </>
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default AmazonProductReturn;